import { Component, DestroyRef, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { DownloadFileHelper } from '@coin/shared/core/util-helpers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EquityPageComponentModel } from '../../models/equity-page-component.model';
import { EquityDocumentsService } from '../../services/equity-documents.service';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'customer-app-equity-download',
  templateUrl: './equity-download.component.html',
  styleUrls: ['./equity-download.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon]
})
export class EquityDownloadComponent implements OnInit, EquityPageComponentModel {
  private readonly equityDocumentsService = inject(EquityDocumentsService);
  private readonly destroyRef = inject(DestroyRef);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() data: any;

  public activeItems = false;
  public keys: string[] = [];

  getFilePath(item): string {
    return `${this.data.options.folderPath}/${item}`;
  }

  ngOnInit(): void {
    if (this.data?.options?.folderPath) {
      this.equityDocumentsService
        .getFileKeysByFolder(this.data.options.folderPath)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(_keys => {
          this.keys = _keys;
        });
    }
  }

  download(fileName: string): void {
    this.equityDocumentsService
      .getFileDownloadUrl({
        key: fileName,
        folderPath: this.data?.options?.folderPath
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(base64Document => DownloadFileHelper.download(base64Document, fileName));
  }
}
